import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import api from '../../services/api';
import { useI18n } from '../../context/useI18n';
import { OrgProvisionSuccessModal } from './OrgOperatorPanel';

const emptyForm = {
  nombre: '',
  company_code: '',
  admin_email: '',
  admin_password: '',
};

/** Plataforma crea holding + admin_marca (solo provisionamiento). */
export default function CreateHoldingModal({ open, onClose, onCreated }) {
  const { t } = useI18n();
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [provisionModal, setProvisionModal] = useState(null);

  useEffect(() => {
    if (!open) return;
    setForm(emptyForm);
    setError('');
  }, [open]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const res = await api.post('/companies', {
        nombre: form.nombre.trim(),
        company_code: form.company_code?.trim() || undefined,
        admin_email: form.admin_email?.trim() || undefined,
        admin_password: form.admin_password?.trim() || undefined,
      });
      const body = res.data || {};
      onCreated?.(body);
      onClose?.();
      if (body.admin_credentials || body.admin_user) {
        setProvisionModal({
          title: t('holding.created', 'Holding creado'),
          adminUser: body.admin_user,
          adminCredentials: body.admin_credentials,
        });
      }
    } catch (err) {
      setError(err.response?.data?.error || t('holding.create_error', 'No se pudo crear el holding'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="form-modal-overlay" style={{ zIndex: 9998 }} role="dialog" aria-modal="true" onClick={onClose}>
        <div className="form-modal ui-light-panel surface-readable w-full max-w-lg" onClick={(e) => e.stopPropagation()}>
          <div className="form-modal-header">
            <h3 className="font-bold">{t('holding.create_title', 'Nuevo holding (marca)')}</h3>
            <button type="button" className="form-close-btn" onClick={onClose} aria-label="Cerrar"><X size={18} /></button>
          </div>
          <form className="form-modal-content space-y-4" onSubmit={handleSubmit}>
            <p className="text-sm text-stone-600">
              {t('holding.create_hint', 'Crea la empresa holding y su admin_marca. Ese usuario solo podrá crear gimnasios virtuales, no operar maestros D28D.')}
            </p>
            {error ? <div className="alert-error text-sm">{error}</div> : null}
            <label className="block text-sm">
              <span className="font-semibold">{t('holding.field_name', 'Nombre del holding')}</span>
              <input className="input mt-1 w-full" required value={form.nombre} onChange={(e) => setForm((p) => ({ ...p, nombre: e.target.value }))} />
            </label>
            <label className="block text-sm">
              <span className="font-semibold">{t('holding.field_admin_email', 'Email admin marca')}</span>
              <input className="input mt-1 w-full" type="email" value={form.admin_email} onChange={(e) => setForm((p) => ({ ...p, admin_email: e.target.value }))} placeholder="admin.marca@empresa.com" />
            </label>
            <label className="block text-sm">
              <span className="font-semibold">{t('holding.field_admin_password', 'Contraseña (opcional)')}</span>
              <input className="input mt-1 w-full" type="password" value={form.admin_password} onChange={(e) => setForm((p) => ({ ...p, admin_password: e.target.value }))} autoComplete="new-password" />
            </label>
            <div className="flex gap-2 pt-2">
              <button type="button" className="btn-secondary flex-1" onClick={onClose}>{t('common.cancel', 'Cancelar')}</button>
              <button type="submit" className="btn-primary flex-1" disabled={saving}>{saving ? t('common.saving', 'Guardando…') : t('holding.create_submit', 'Crear holding')}</button>
            </div>
          </form>
        </div>
      </div>
      <OrgProvisionSuccessModal
        open={!!provisionModal}
        onClose={() => setProvisionModal(null)}
        title={provisionModal?.title}
        adminUser={provisionModal?.adminUser}
        adminCredentials={provisionModal?.adminCredentials}
      />
    </>
  );
}
